import { createFileRoute } from '@tanstack/react-router';
import { useLang } from '@/lib/LanguageContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { LegalPageWrap } from '@/components/shared/LegalPageWrap';
import { ColophonContent } from '@/components/sections/colophon-content';

// ═══════════════════════════════════════════════════════════
// /colophon — page SEO du Colophon d'Océanne.
// Pendant routable du modal Colophon (ColophonContent variant="page").
// Phase 27.81 — voix Océanne : typo + palette + principes + équipe + a11y + stack.
// E-E-A-T boost pour SEO (transparence méthode/standards).
//
// Phase 27.84 — lazy-load ColophonContent. Le Schema.org Person + meta
// titre/description/canonical sont SSR-injectés par le Worker (route-meta.ts +
// schema-org.ts) ; aucune dépendance au chunk lazy pour le crawler.
//
// Phase 27.84b — REVERT lazy-load. Le contenu DOIT être eager pour que les
// crawlers LLM (ChatGPT/Perplexity/Bing/etc.) qui ne rendent pas le JS voient
// le HTML complet. Le modal reste lazy (colophon-modal.tsx) pour la perf UX.
// ═══════════════════════════════════════════════════════════

export function ColophonPage() {
  const { lang } = useLang();
  const text = ta(t.colophon, lang);

  return (
    <LegalPageWrap
      eyebrow={text.eyebrow}
      title={text.title}
      intro={text.intro}
      maxWidth="max-w-3xl"
    >
      <ColophonContent variant="page" />
    </LegalPageWrap>
  );
}

export const Route = createFileRoute('/colophon')({
  component: ColophonPage
});
